import { CreateObituaryParserResponse } from '@/api/requests/llm/obituaryParserInterfaces';
import { Text, Icons, Stack, styled, Box } from '@/theme/index';
import {
  ObituaryRelativesEmptyBox,
  StyledText,
  StyledAccomplishment,
} from './constants';

export interface ObituaryLifeEventsProps {
  llmAccomplishments: CreateObituaryParserResponse['data']['accomplishments'];
  name: string;
}

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  marginBottom: '20px',
}));

export function ObituaryAccomplishments({
  llmAccomplishments,
  name,
}: ObituaryLifeEventsProps) {
  return (
    <StyledBox>
      <Text
        variant="h4"
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '15px',
        }}
      >
        <Icons.EmojiEvents style={{ marginRight: '5px' }} />
        Accomplishments
      </Text>
      <Stack flexDirection="row" flexWrap="wrap">
        {llmAccomplishments.length ? (
          llmAccomplishments.map((accomplishment, index) => (
            <StyledAccomplishment key={`${index}-accomplishment`}>
              {accomplishment}
            </StyledAccomplishment>
          ))
        ) : (
          <ObituaryRelativesEmptyBox>
            <StyledText>
              No Possible Career Highlights associated with {name} were found.
            </StyledText>
          </ObituaryRelativesEmptyBox>
        )}
      </Stack>
    </StyledBox>
  );
}
